import { useFirebase } from '../../../contexts/FirebaseContext';
import { Container } from 'react-bootstrap';
import { AppShell } from '../../components/AppShell/AppShell';
import { Footer } from '../../components/Footer/Footer';
import { Title } from '../../components/Title/Title';
import { FullscreenLoader } from '../../components/FullscreenLoader/FullscreenLoader';
import { VideoCard } from '../../components/VideoCard/VideoCard';
import { useTranslation } from 'react-i18next';
import styles from './MyList.module.scss';

const MyListComponent = () => {
  const { myList } = useFirebase();
  const { t } = useTranslation();

  return (
    <AppShell>
      <div className="d-flex flex-column flex-grow-1">
        <Title>{t('labels.mieiToot')}</Title>

        {!myList && <FullscreenLoader fullscreen={false} />}

        {!!myList && (
          <>
            {!myList.length && (
              <div className={'my-5'}>
                <h1 className={'text-center display-4'}>{t('myList.labels.nonHaiAggiunto')}</h1>
                <p className={'text-center'}>{t('myList.labels.aggiungiQualcosa')}</p>
              </div>
            )}
            {!!myList.length && (
              <Container className="flex-grow-1">
                <div className={styles.videoGrid}>
                  {myList.map((video, index) => (
                    <VideoCard className="m-1" key={video.id} index={index} video={video} />
                  ))}
                </div>
              </Container>
            )}
          </>
        )}

        <Footer />
      </div>
    </AppShell>
  );
};

export default MyListComponent;
